export {
	getLocale,
	createIntlShape,
	getDictionary,
} from './getTranslation'
export type { Replacements, Locale } from './getTranslation'
export type { TranslationKey, Language } from './types'
export { flattenObject } from './utils'
